import { render, staticRenderFns } from "./OrderDetailsComponent.vue?vue&type=template&id=3c7a5dbf&scoped=true&"
import script from "./OrderDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsComponent.vue?vue&type=style&index=0&id=3c7a5dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a5dbf",
  null
  
)

export default component.exports